import {
  BuildingRequest,
  BuildingWithTrusses,
  GableTruss,
  HeaderTruss,
  LeanToTruss,
} from '../../types';
import {
  postSizeDisplayToEnum,
  postSizeEnumToDisplay,
  WidthMeasurementReference,
} from '../order/building-constants';
import {
  gableTrussToRequest,
  headerTrussToRequest,
  leanToTrussToRequest,
} from '../order/truss-utils';

// Classification-aware 6x6 post-size validation is shared with the Order Details path
// (UDOMI-966). Re-exported here so existing traveler imports keep working.
export {
  validatePostSizeForTrusses,
  withRecalculatedInsidePostMeasurements,
} from '../order/truss-utils';

export function buildingToCartUpdateRequest(
  building: BuildingWithTrusses,
  gable: GableTruss[],
  header: HeaderTruss[],
  leanTo: LeanToTruss[],
  orderDate: string
): BuildingRequest {
  const postSizeDisplay = postSizeEnumToDisplay[building.postSize] || building.postSize;
  const postSizeEnum = postSizeDisplayToEnum[postSizeDisplay] || building.postSize;
  const trusses = [
    ...gable.map(t => gableTrussToRequest(t, orderDate)),
    ...header.map(t => headerTrussToRequest(t, orderDate)),
    ...leanTo.map(t => leanToTrussToRequest(t, orderDate)),
  ];
  return {
    orderId: building.orderId,
    name: building.name,
    confirmedLoadRating: building.confirmedLoadRating ?? false,
    width: building.width,
    length: building.length,
    height: building.height,
    baySpacing: building.baySpacing,
    postSize: postSizeEnum,
    widthMeasurementReference:
      building.widthMeasurementReference ?? WidthMeasurementReference.OutsideOutside,
    application: building.application,
    additionalNotes: building.additionalNotes,
    isPermanentDwelling: building.isPermanentDwelling,
    includePermanentDwellingWithPoleBarn:
      building.includePermanentDwellingWithPoleBarn ?? undefined,
    includePermanentDwellingForPartiallyClosedPoleBarn:
      building.includePermanentDwellingForPartiallyClosedPoleBarn ?? undefined,
    includePermanentDwellingForFullyEnclosedPoleBarn:
      building.includePermanentDwellingForFullyEnclosedPoleBarn ?? undefined,
    includePermanentDwellingWithNoMEP: building.includePermanentDwellingWithNoMEP ?? undefined,
    trusses,
    trussesProvided: true,
  };
}
